import { Component, EventEmitter, Input, Output } from '@angular/core';

import { TAdaptedReferenceV3, TAdoptedQuizItem } from '../../../types/types';

import { NewSourcePreviewButtonComponent } from '../source-preview/new-button/new-source-preview-button.component';

@Component({
    selector: 'app-quiz-reference',
    templateUrl: './quiz-reference.component.html',
    styleUrls: ['./quiz-reference.component.css'],
    standalone: true,
    imports: [NewSourcePreviewButtonComponent]
})
export class QuizReferenceComponent {
  @Output() openSourceModal = new EventEmitter<TAdaptedReferenceV3>();

  @Input() answer: TAdoptedQuizItem | undefined;
}
